export default __webpack_public_path__ + "static/media/img_noData.ad3ec64a.svg";